var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-chip',{staticClass:"product-order-status",attrs:{"color":_vm.danger}},[_vm._v("hh")])}
var staticRenderFns = []

export { render, staticRenderFns }